import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {useTranslation} from "react-i18next";
import {get, patch} from "../../../../controlers/global/ConfigRequest";
import {EDIT_ORDER_STATUS, GET_ORDER_LIST_WITHOUT_PAGINATION} from "../../../../helperData/ApiAddress";
import moment from "jalali-moment";
import {ReactComponent as Coin} from "../../../../asset/icons/coin.svg";
import DBButton from "../../../../component/global/DBButton";
import TakingOrderModal from "./TakingOrderModal";
import DBTable from "../../../../component/global/DBTable/DBTable";
import {Spinner} from "react-bootstrap";

const initialStateDetailModal = {show: false, data: {}}

function TakingOrderTable(props) {
  const {status, hasAction, nextStatus} = props
  const [detailModal, setDetailModal] = useState(initialStateDetailModal)
  const {t} = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState([])
  const [btnActionLoading, setBtnActionLoading] = useState(false)
  const [refreshData, setRefreshData] = useState(false)

  const takingOrderStatus = useMemo(() => {
    return [
      {
        id: 1,
        title: t("Organizational.Restaurant.TakingOrder.New.Tab")
      },
      {
        id: 2,
        title: t("Organizational.Restaurant.TakingOrder.Preparing.Tab")
      },
      {
        id: 3,
        title: t("Organizational.Restaurant.TakingOrder.Delivery.Tab")
      },
      {
        id: 4,
        title: t("Organizational.Restaurant.TakingOrder.Closed.Tab")
      },
    ]
  }, [t])

  const headers = useMemo(() => {
    const tmp = [
      {
        id: 'order',
        title: t('Organizational.Restaurant.TakingOrder.Table.Order'),
        gridTemplateColumns: 'auto'
      },
      {
        id: 'customer',
        title: t('Organizational.Restaurant.TakingOrder.Table.Customer'),
        gridTemplateColumns: '200px'
      },
      {
        id: 'code',
        title: t('Organizational.Restaurant.TakingOrder.Table.Code'),
        gridTemplateColumns: '100px',
      },
      {
        id: 'orderDate',
        title: t('Organizational.Restaurant.TakingOrder.Table.OrderDate'),
        gridTemplateColumns: '100px',
      },
      {
        id: 'numberBuy',
        title: t('Organizational.Restaurant.TakingOrder.Table.NumberBuy'),
        gridTemplateColumns: '80px',
        rowStyle: {textAlign: 'center'},
      },
      {
        id: 'time',
        title: t('Organizational.Restaurant.TakingOrder.Table.Time'),
        gridTemplateColumns: '80px',
      },
      {
        id: 'price',
        title: t('Organizational.Restaurant.TakingOrder.Table.Price'),
        gridTemplateColumns: '120px',
        numberWithComma: true,
      },
      {
        id: 'feedCoin',
        title: t('Organizational.Restaurant.TakingOrder.Table.FeedCoin'),
        gridTemplateColumns: '80px',
      },
    ]
    if (hasAction) {
      tmp.push({
        id: 'action',
        title: t('Organizational.Restaurant.TakingOrder.Table.Action'),
        gridTemplateColumns: '100px',
      })
    }
    return tmp
  }, [hasAction, t])

  useEffect(() => {
    let timeout = null

    function getData() {
      setIsLoading(true)
      get(GET_ORDER_LIST_WITHOUT_PAGINATION, {status})
        .then(res => {
          console.log('TakingOrderTable getData res', status, res)
          let tmp = res?.length ? res : []
          setData(tmp)
        })
        .catch(err => {
          console.log('TakingOrderTable getData res', err)
        })
        .finally(() => {
          setIsLoading(false)
          clearTimeout(timeout)
          timeout = setTimeout(() => {
            getData()
          }, 10000)
        })
    }

    getData()

    return () => {
      clearTimeout(timeout)
      console.log('clear', status, timeout)
    }
  }, [status, refreshData])

  const changeStatus = useCallback((nextStatus, id) => {
    if (nextStatus) {
      setBtnActionLoading(true)
      patch(EDIT_ORDER_STATUS.replace(':id', id), {status: nextStatus})
        .then(res => {
          console.log('TakingOrderTable EDIT_ORDER_STATUS res', res)
          if (res?.id) {
            setDetailModal(initialStateDetailModal)
            setRefreshData(prevState => !prevState)
          }
        })
        .catch(err => {
          console.log('TakingOrderTable EDIT_ORDER_STATUS err', err)
        })
        .finally(() => setBtnActionLoading(false))
    }
  }, [])

  const rows = useMemo(() => {
    let tmp = []
    if (data?.length) {
      tmp = data?.map(item => {
        const id = item?.id
        const order = item?.order_items?.map(item => item?.item_name)?.join(" , ") || ""
        const customer = (item?.user?.first_name || '') + " " + (item?.user?.last_name || '')
        const code = item?.code
        const orderDate = moment(item?.create_at).format('jYYYY/jMM/jDD')
        const numberBuy = item?.user_total_orders
        const time = moment(item?.create_at).format('HH:MM')
        const price = item?.total_price
        const feedCoin = <>{item?.coin}<Coin/></>
        const orderItems = item?.order_items
        const phoneNumber = item?.user?.phone_number?.replace('+', '')
        const status = takingOrderStatus.find(el => el.id === item.status)?.title || ''

        const tmp = {
          order,
          customer,
          code,
          orderDate,
          numberBuy,
          time,
          price,
          feedCoin,
          orderItems,
          status,
          phoneNumber,
          id
        }
        if (hasAction) {
          tmp.action = <DBButton
            caption='مرحله بعد'
            className='btn-close'
            loading={btnActionLoading}
            onClick={(e) => {
              e.stopPropagation()
              changeStatus(nextStatus, item.id)
            }}
          />
        }
        return tmp
      })
    }
    return tmp
  }, [btnActionLoading, changeStatus, data, hasAction, nextStatus, takingOrderStatus])


  function showTable() {
    if (isLoading) return <Spinner animation="border"/>
    if (data?.length) {
      return (
        <DBTable
          minWidth={1176}
          headers={headers}
          rows={rows}
          onClickRow={(item) => {
            if (!btnActionLoading) {
              setDetailModal({
                show: true,
                data: item
              })
            }
          }}
        />
      )
    }
    return <div className='takingOrder-notFound'>{t('Organizational.Restaurant.TakingOrder.Table.NotFound')}</div>
  }

  return (
    <>
      <TakingOrderModal
        show={detailModal.show}
        onHide={() => {
          if (!btnActionLoading) {
            setDetailModal(initialStateDetailModal)
          }
        }}
        data={detailModal.data}
        loading={btnActionLoading}
        onClickBtn={() => {
          changeStatus(nextStatus, detailModal.data?.id)
        }}
      />
      {showTable()}
    </>
  );
}

export default TakingOrderTable;
